// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../platform/@jutro/cli-app/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../platform/@jutro/cli-app/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".app__WizardSingleErrorComponent__gwIssuesContainer{margin-top:var(--GW-SPACING-5)}", "",{"version":3,"sources":["webpack://./src/overrides/modules-react/e1p-components-platform-react/WizardSingleErrorComponent/WizardSingleErrorComponent.module.scss"],"names":[],"mappings":"AAAA,oDACE,8BAAA","sourcesContent":[".gwIssuesContainer {\n  margin-top: var(--GW-SPACING-5);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"gwIssuesContainer": "app__WizardSingleErrorComponent__gwIssuesContainer"
};
export default ___CSS_LOADER_EXPORT___;
